import tafFetch, { checkRes } from "./_tafFetch";
import { HUYA } from "@/assets/jce/LuckyBagServant";

// 模版例子
export async function getLuckyBagPanel() {
  const req = new HUYA.LuckyBagCommReq();
  const res = await tafFetch({
    data: req,
    funcName: "getLuckyBagPanel",
    moduleName: "wupui",
    ReqClass: HUYA.LuckyBagCommReq,
    RspClass: HUYA.LuckyBagPanel,
  });
  checkRes(res);
  return res;
}
